import { WithAlert } from '@components/design';
import { feedback } from '@ecosystem/newron-design-system';

const { ActionType } = feedback;

export const LimitPgInfo = () => {
  return (
    <div className="my-4">
      <WithAlert
        title="Apply a Filter of up to 10 Product Groups to view Brand leaderboard."
        type="info"
        actionType={ActionType.DEFAULT}
      />
    </div>
  );
};
